import { atom } from "recoil";

export const DicBoTieuChiState = atom({
  key: "DicBoTieuChiState",
  default: undefined,
});
